<rt-dialog-header
  [heading]="'app.offers.archive_offers.title' | translate"
  [subheading]="'app.offers.archive_offers.subtitle' | translate"
/>

<rt-dialog-body>
  <rt-box variant="vertical background no-padding">
    <div class="search">
      <rt-form-field>
        <rt-input
          variant="rounded"
          placeholder="{{ 'app.common.placeholders.search.offers.other' | translate }}"
          [autoFocus]="true"
          [formControl]="searchControl"
          [hasClearButton]="true"
          (reset)="cancelSearch()"
        >
          <rt-icon prefix name="search" />
        </rt-input>
      </rt-form-field>
    </div>

    @if (jobs | rtQueryFilter: 'title' : searchControl.value; as filteredJobs) {
      <div class="scroll-container">
        @for (offer of filteredJobs; track trackByOffer($index, offer); let isLastOffer = $last) {
          <div class="offer">
            <rt-group variant="horizontal" class="offer-inner">
              <rt-offer-status-indicator [offerStatus]="offer" />
              <div class="offer-title">
                <rt-heading>{{ offer.title }}</rt-heading>
                <span>{{ offer.location }}</span>
              </div>
              <div class="offer-action">
                <rt-button (click)="archiveOffer(offer)" variant="tertiary">
                  <rt-icon name="archive" />
                  <span>{{ 'app.offers.archive' | translate }}</span>
                </rt-button>
              </div>
            </rt-group>
            @if (!isLastOffer) {
              <rt-divider />
            }
          </div>
        }
        @if (searchControl.value !== '' && !filteredJobs.length) {
          <rt-empty-state
            variant="small"
            [icon]="'error-outline'"
            [title]="'app.common.no_results_found' | translate"
          >
            <rt-button variant="tertiary" (click)="cancelSearch()">
              {{ 'app.assignments.editor.clear_search' | translate }}
            </rt-button>
          </rt-empty-state>
        }
      </div>
    }
  </rt-box>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button variant="primary" (click)="close()">
    {{ 'app.common.done' | translate }}
  </rt-button>
</rt-dialog-footer>
